import { render, staticRenderFns } from "./marshall_warnings.vue?vue&type=template&id=035c4222&scoped=true"
import script from "./marshall_warnings.vue?vue&type=script&lang=js"
export * from "./marshall_warnings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035c4222",
  null
  
)

export default component.exports